export {
  GRADING_THRESHOLDS,
  SPLIT_THRESHOLDS,
  STRUCTURE_EDITOR_BBX_THRESHOLDS,
  STRUCTURE_READONLY_ON_CONFIRM,
  SUBMISSION_READONLY_ON_CONFIRM,
} from '../../shared/constants.js';

/** Embedded Legal Navigator, shown in the 'legal' canvas when the agent is addressed on legal/regulatory topics. */
export const LEGAL_NAVIGATOR_URL = 'https://gradias-legal-navigator.mbn1974.chatgpt.site/';
